/**
 * HappyDiertjes – Ledknipper Redesign Animaties
 * Scroll-triggered fade-in voor secties + stat counter animatie
 * Vanilla JS, geen dependencies.
 */
(function () {
  'use strict';

  /* ── Scroll-triggered fade-in ── */
  const SECTIONS = [
    '.hd-hiw',
    '.hd-hiw-steps .hd-step',
  ];

  function initScrollAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = document.querySelectorAll(SECTIONS.join(','));
    if (!targets.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hd-animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    targets.forEach(function (el) {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

  /* ── Stat counter animatie (0 → eindwaarde) ── */
  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Easing: ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target) + '%';
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initStatCounters() {
    var statEls = document.querySelectorAll('.results__percentage');
    if (!statEls.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = parseInt(entry.target.textContent, 10);
            if (!isNaN(target)) {
              animateCounter(entry.target, target, 1200);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    statEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollAnimations();
      initStatCounters();
    });
  } else {
    initScrollAnimations();
    initStatCounters();
  }
})();
